import { registerPlugin } from '@wordpress/plugins';
import {
    __experimentalFullscreenModeClose as FullscreenModeClose,
    __experimentalMainDashboardButton as MainDashboardButton,
} from '@wordpress/edit-post';
 
const MainDashboardButtonIconTest = () => (
    <MainDashboardButton>
        <FullscreenModeClose href="admin.php?page=wpdae-template" />
    </MainDashboardButton>
);
 
registerPlugin( 'wp-apidae-main-button-dashboard', {
    render: MainDashboardButtonIconTest,
} );